/* -----------------Globals--------------- */
import { Image } from "react-native";

/* -----------------Child components--------------- */
import Loader from "@memorang/ui/components/Loader";

/* -----------------Third parties--------------- */
import useExams from "@hooks/useExams";
import type { Category } from "@memorang/types";
import CategoryChooseScreen from "@memorang/ui/components/CategoryChooseScreen";
import type { CategoryItem } from "@memorang/ui/components/CategoryChooseScreen/CategoryGrid";
import { useEffect, useMemo } from "react";
import type { NextButtonHandler } from "../types";

type Props = {
	handleCategorySelect: (id: string) => void;
	selectedCategoryId?: string;
	categoryHasState?: boolean;
	cta?: string;
	handleNextAction: NextButtonHandler;
	reset: () => void;
};

export const ChooseCategoryContainer = ({
	handleCategorySelect,
	selectedCategoryId,
	categoryHasState,
	cta,
	handleNextAction,
	reset,
}: Props) => {
	const { categories } = useExams();

	const handleNext = () => {
		handleNextAction(categoryHasState ? "chooseLevel" : "chooseContext");
	};

	useEffect(() => {
		reset();
	}, [reset]);

	const selectedCategoryName = useMemo(() => {
		return (
			categories?.find((category) => category.id === selectedCategoryId)
				?.name ?? ""
		);
	}, [categories, selectedCategoryId]);

	if (!categories?.length) {
		return <Loader />;
	}

	const categoryItems: CategoryItem[] = categories.map(
		(category: Category) => ({
			id: category.id,
			title: category.name,
			image: (
				<Image
					source={{ uri: category.icon }}
					style={{
						width: 100,
						height: 100,
					}}
					resizeMode="contain"
				/>
			),
		}),
	);

	return (
		<CategoryChooseScreen
			items={categoryItems}
			selectedId={selectedCategoryId}
			onSelect={handleCategorySelect}
			handleNext={handleNext}
			selectedCategoryName={selectedCategoryName}
			cta={cta}
			disabled={!selectedCategoryId}
		/>
	);
};
